<template>
    <v-toolbar
        flat
        v-if="!item.props.noCreate"
        style="background-color: transparent"
    >
        <template v-if="alert || item.props.alert" v-slot:extension>
            <v-alert 
                type="warning"
                dense
            >
                {{alert || item.props.alert}}
            </v-alert>
        </template>
        
        <v-btn
            color="primary"
            :disabled="readonly"
            v-on:click="$emit('newItem')"
        >
            {{item.props.newItemLabel}}
        </v-btn>
        
        <div class="flex-grow-1"></div>
        
        <template v-if="item.props.tooltip">
            <v-tooltip
                top
            >
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="mr-n4">mdi-information</v-icon>
                </template>
                <div v-html="item.props.tooltip"></div>
            </v-tooltip>
        </template>
    </v-toolbar>
</template>

<script>
import dataTableMixins from './mixins/data-table-mixins';

    export default {
        mixins: [dataTableMixins],
        name: 'DataTableToolbar',
        props: [
            'alert', 
            'item', 
            'readonly'
        ]
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/data-table-toolbar.vue